import { render, staticRenderFns } from "./ExtractFieldsDialog.vue?vue&type=template&id=ccefa52c"
import script from "./ExtractFieldsDialog.vue?vue&type=script&lang=js"
export * from "./ExtractFieldsDialog.vue?vue&type=script&lang=js"
import style0 from "./ExtractFieldsDialog.vue?vue&type=style&index=0&id=ccefa52c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports